import React, { useState } from "react";
import "../../Components/Boot/Boot.css";
import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";
import MobileFooter from "../../Components/Mobile/MobileFooter";
import "./FrequentlyAsked.css";

const faqData = [
  {
    question: "What areas do you deliver to?",
    answer:
      "We currently deliver to Lagos and Abuja metropolitan areas. Delivery availability may vary by service.",
  },
  {
    question: "What are your delivery times?",
    answer:
      "Delivery times depend on your location and service selected. Typically, grocery deliveries arrive within 2-4 hours during business hours.",
  },
  {
    question: "How do I track my order?",
    answer: "Once your order is confirmed, you can check your orders page.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept payments via Paystack, which supports card payments and mobile money wallets.",
  },
  {
    question: "Can I cancel or change my order?",
    answer:
      "Orders can be modified or cancelled within 10 minutes of placement by contacting our support chat.",
  },
  {
    question: "What is your refund policy?",
    answer:
      "If there are issues with your order, please contact support within 24 hours. Refunds are processed on a case-by-case basis.",
  },
];

function FrequentlyAsked() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div className="mc d-lg-none d-xl-none d-xxl-none d-md-none d-xs-block">
        <div className="mc-header navbar">
          <h5>F.A.Q</h5>
        </div>
        <section className="faq-section">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-list">
            {faqData.map((item, index) => (
              <div
                key={index}
                className={`faq-item ${openIndex === index ? "open" : ""}`}
                onClick={() => toggleFAQ(index)}
              >
                <div className="faq-question">
                  <span>{item.question}</span>
                  <span className="faq-toggle">
                    {openIndex === index ? "-" : "+"}
                  </span>
                </div>
                {openIndex === index && (
                  <div className="faq-answer">{item.answer}</div>
                )}
              </div>
            ))}
          </div>
        </section>
        <MobileFooter />
      </div>
      <div className="d-none d-md-block">
        <Navbar />
        <div className="d-flex align-items-center justify-content-center">
          <section className="faq-section">
            <h2>Frequently Asked Questions</h2>
            <div className="faq-list">
              {faqData.map((item, index) => (
                <div
                  key={index}
                  className={`faq-item ${openIndex === index ? "open" : ""}`}
                  onClick={() => toggleFAQ(index)}
                >
                  <div className="faq-question">
                    <span>{item.question}</span>
                    <span className="faq-toggle">
                      {openIndex === index ? "-" : "+"}
                    </span>
                  </div>
                  {openIndex === index && (
                    <div className="faq-answer">{item.answer}</div>
                  )}
                </div>
              ))}
            </div>
          </section>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default FrequentlyAsked;
